var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Update",
            "ok-title": "Yes, Save"
          },
          on: { ok: _vm.saveDepartmentFn, cancel: _vm.resetData },
          model: {
            value: _vm.showUpdateDepartment,
            callback: function($$v) {
              _vm.showUpdateDepartment = $$v
            },
            expression: "showUpdateDepartment"
          }
        },
        [
          _c("p", [
            _vm._v(
              "Changes made to the department will be reflected in all deliverables it is being used at. Are you sure you want to save the department?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var handleSubmit = ref.handleSubmit
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.showConfirmModal)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Title*")]),
                            _vm._v(" "),
                            _c("ValidationProvider", {
                              attrs: { mode: "passive", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.departmentData.title,
                                              expression: "departmentData.title"
                                            }
                                          ],
                                          ref: "focusThis",
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: _vm.departmentData.title
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.departmentData,
                                                "title",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Abbreviation")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.departmentData.abbreviation,
                                expression: "departmentData.abbreviation"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.departmentData.abbreviation
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.departmentData,
                                  "abbreviation",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            [
                              _vm._v("Active: "),
                              _c("switches", {
                                attrs: { theme: "bootstrap", color: "primary" },
                                model: {
                                  value: _vm.departmentData.is_active,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.departmentData,
                                      "is_active",
                                      $$v
                                    )
                                  },
                                  expression: "departmentData.is_active"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          _vm._l(
                            _vm.$lodash.filter(
                              _vm.departmentData.departmentCustomFields,
                              { field_key: "engagement_manager" }
                            ),
                            function(field, index) {
                              return _c(
                                "div",
                                {
                                  key:
                                    "dept__" + field.field_key + "__" + index,
                                  staticClass: "field-box"
                                },
                                [
                                  _c("DepartmentCustomField", {
                                    key: "deptfields" + _vm.departmentData.id,
                                    attrs: {
                                      deliverable: _vm.departmentData,
                                      customField: field
                                    }
                                  })
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "submit", "data-dismiss": "modal" }
                            },
                            [_vm._v("Save")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }